var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF403D",
  fillRule: "evenodd",
  d: "M10.659 1.172a2.57 2.57 0 0 1 3.63 1.022l.004.009 8.642 17.283v.001a2.57 2.57 0 0 1-2.29 3.727H3.355a2.57 2.57 0 0 1-2.29-3.727l.002-.002L9.71 2.194c.216-.421.544-.775.948-1.022",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12 7.857a1 1 0 0 1 1 1v5.107a1 1 0 1 1-2 0V8.857a1 1 0 0 1 1-1",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.607 17.893a1.393 1.393 0 1 1 2.786 0 1.393 1.393 0 0 1-2.786 0"
})));
export default SvgWarning;